import React from 'react';
import { SearchIcon, LogInIcon, HomeIcon, CalendarIcon, UserIcon } from 'lucide-react';
export function MobileBottomNav() {
  return <nav className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 shadow-[0_-4px_24px_rgba(0,85,150,0.12)] bottom-nav-safe" role="navigation" aria-label="Mobile bottom navigation" data-id="element-218">
      <div className="grid grid-cols-5 h-16" data-id="element-219">
        <a href="#" className="flex flex-col items-center justify-center gap-1 text-medical-blue" aria-label="Home" aria-current="page" data-id="element-220">
          <HomeIcon className="w-5 h-5" data-id="element-221" />
          <span className="text-[10px] font-semibold" data-id="element-222">Home</span>
        </a>

        <a href="#" className="flex flex-col items-center justify-center gap-1 text-text-muted hover:text-medical-blue transition-colors" aria-label="Search shifts" data-id="element-223">
          <SearchIcon className="w-5 h-5" data-id="element-224" />
          <span className="text-[10px] font-medium" data-id="element-225">Search</span>
        </a>

        {/* Center: Quick Find CTA */}
        <a href="#hero" className="flex flex-col items-center justify-center" aria-label="Find care now" data-id="element-226">
          <div className="w-12 h-12 bg-medical-blue rounded-2xl flex items-center justify-center shadow-lg -mt-4 border-4 border-white" data-id="element-227">
            <CalendarIcon className="w-5 h-5 text-white" data-id="element-228" />
          </div>
          <span className="text-[10px] font-semibold text-medical-blue mt-0.5" data-id="element-229">
            Book
          </span>
        </a>

        <a href="#" className="flex flex-col items-center justify-center gap-1 text-text-muted hover:text-medical-blue transition-colors" aria-label="My shifts" data-id="element-230">
          <CalendarIcon className="w-5 h-5" data-id="element-231" />
          <span className="text-[10px] font-medium" data-id="element-232">Shifts</span>
        </a>

        <a href="#" className="flex flex-col items-center justify-center gap-1 text-text-muted hover:text-medical-blue transition-colors" aria-label="Log in or profile" data-id="element-233">
          <LogInIcon className="w-5 h-5" data-id="element-234" />
          <span className="text-[10px] font-medium" data-id="element-235">Login</span>
        </a>
      </div>
    </nav>;
}